export const WIDGET_FRAME_TITLE_CLASS = "widget-frame-title";
